<template>
  <div>
    <div class="min-h-screen flex justify-center items-center">
      <section class="lg:w-1/2 px-8 py-base">
        <slot />
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
